import { SxProps } from "@mui/material/styles";
import { Stack, Tab, Tabs } from "@mui/material";
import { a11yProps } from "../Common/UI/TabPanel";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import {
  resetResponseFormState,
  setResponseCategory,
} from "../../Redux/reducers/responseSlice";
import { computeEditablePermission } from "../../Redux/actions/responseAction";
import { featuresMap } from "../../utils/features";
import { canShowSurveysTab } from "../../utils/surveyEligibility";

const responsesSubheader: SxProps = {
  bgcolor: "background.paper",

  border: "1px solid",
  borderColor: "divider",
  borderLeft: "none",
  borderRight: "none",
};

const CategoryTabs = () => {
  const dispatch = useAppDispatch();

  const currentCategory = useAppSelector(
    (state) => state.response.currentCategory
  );

  const viewRandomization = useAppSelector(
    (state) => state.response.viewRandomization
  );

  const isResponseSubmitting = useAppSelector(
    (state) => state.response.fieldSubmitting
  );

  const isResponseLoading = useAppSelector((state) => state.response.isLoading);

  const features = useAppSelector((state) => state.study.features);
  const eligibilityStatus = useAppSelector(
    (state) => state.response.eligibilityStatus
  );

  const resetSliceStates = () => {
    dispatch(resetResponseFormState());
  };

  const changetabIndex = (_: any, value: string) => {
    if (isResponseSubmitting || isResponseLoading) return;

    resetSliceStates();

    dispatch(computeEditablePermission(value));
    dispatch(setResponseCategory(value));
    sessionStorage.setItem("response-view", value);
  };

  return (
    <Stack sx={responsesSubheader}>
      <Tabs
        value={currentCategory}
        onChange={changetabIndex}
        aria-label="Response Category Tabs"
        sx={{ height: "48px" }}
      >
        {features?.[featuresMap.visit] && (
          <Tab
            label={"Screening"}
            value="screening"
            {...a11yProps(5)}
            sx={{ textTransform: "capitalize" }}
          />
        )}
        {features?.[featuresMap.visit] && (
          <Tab
            label={"Visit"}
            value="visit"
            {...a11yProps(0)}
            sx={{ textTransform: "capitalize" }}
          />
        )}
        {features?.[featuresMap.repeatedData] && (
          <Tab
            label={"Repeating Data"}
            value="repeated_data"
            {...a11yProps(1)}
            sx={{ textTransform: "capitalize" }}
          />
        )}

        {viewRandomization && features?.[featuresMap.randomization] && (
          <Tab
            label="Randomization"
            value="randomization"
            {...a11yProps(2)}
            sx={{ textTransform: "capitalize" }}
          />
        )}

        {features?.[featuresMap.survey] &&
          canShowSurveysTab(eligibilityStatus) && (
          <Tab
            label={"Surveys"}
            value="surveys"
            {...a11yProps(3)}
            sx={{ textTransform: "capitalize" }}
          />
        )}
        <Tab
          label={"Documents"}
          value="documents"
          {...a11yProps(4)}
          sx={{ textTransform: "capitalize" }}
        />
      </Tabs>
    </Stack>
  );
};
export default CategoryTabs;
